<template>
  <div v-show="isTopicContentViewActiveLocal" ref="topic_content" class="dark-layout">
    <div class="vx-row limit-width_fixed-scalable">
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>
      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card
          v-if="!isStudent"
          class="glow-effect_dark limit-width_fixed card__no-padding bg-color"
        >
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span
                  ><feather-icon
                    class="pt-1"
                    icon="MessageCircleIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color=""
              @click="backToPickLanguage"
            >
              <span id="backArrow"
                ><feather-icon
                  class="pt-1 back-icon__hover-only"
                  icon="ArrowLeftIcon"
                  svg-classes="stroke-current"
                ></feather-icon
              ></span>
              {{ selectedLanguage }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card
          v-if="!isStudent"
          class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color"
        >
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span
                  ><feather-icon
                    class="pt-1"
                    icon="BookmarkIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color=""
              @click="backToPickGrade"
            >
              <span id="backArrow"
                ><feather-icon
                  class="pt-1 back-icon__hover-only"
                  icon="ArrowLeftIcon"
                  svg-classes="stroke-current"
                ></feather-icon
              ></span>
              {{ selectedGrade.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card
          class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color"
        >
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <img height="25" :src="selectedSubject.icon" />
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color=""
              @click="backToPickSubject"
            >
              <span id="backArrow"
                ><feather-icon
                  class="pt-1 back-icon__hover-only"
                  icon="ArrowLeftIcon"
                  svg-classes="stroke-current"
                ></feather-icon
              ></span>
              {{ selectedSubject.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card
          class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color"
        >
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span
                  ><feather-icon
                    class="pt-1"
                    icon="CodesandboxIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color=""
              @click="backToPickModule"
            >
              <span id="backArrow"
                ><feather-icon
                  class="pt-1 back-icon__hover-only"
                  icon="ArrowLeftIcon"
                  svg-classes="stroke-current"
                ></feather-icon
              ></span>
              {{ selectedModule.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card
          class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color"
        >
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span
                  ><feather-icon
                    class="pt-1"
                    icon="DiscIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
              style="border-radius:0 7px 7px 0"
              type="filled"
              color=""
              @click="backToPickTopic"
            >
              <span id="backArrow"
                ><feather-icon
                  class="pt-1 back-icon__hover-only"
                  icon="ArrowLeftIcon"
                  svg-classes="stroke-current"
                ></feather-icon
              ></span>
              {{ selectedTopic.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="mt-8">
      <ul style="margin-top: 1rem;flex-wrap: wrap;">
        <div class="limit-width_fixed-scalable" style="text-align: left;">
          <li
            v-if="
              (selectedTopic.structuredLessonAvailable && isStudent) ||
                (selectedTopic.structuredLessonAvailable &
                  !selectedTopic.structuredLessonEditable &&
                  !isStudent)
            "
            class="my-4"
          >
            <vx-card
              class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color"
            >
              <div>
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text input-group_prepend-slot-bg">
                      <span
                        ><feather-icon
                          class="pt-1"
                          icon="GridIcon"
                          svg-classes="stroke-current"
                        ></feather-icon
                      ></span>
                    </div>
                  </template>
                  <p class="glow-effect_primary" style="display: flex; align-items: center; flex-direction: row; border-radius:0 7px 7px 0" >
                    <vs-button
                      ref="continueWatchingBtn"
                      size="large"
                      class="w-full  button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0"
                      @click="goToLesson"
                    > 
                      Go To Structured Lesson 
                    </vs-button>
                    <img v-if="selectedTopic.isPremium" class="footer-social ml-3 mr-3" src="@/assets/images/royal-crown-with-three-picks-svgrepo-Gold.png" height="38" />
                  </p>
                  
                </vx-input-group>
              </div>
            </vx-card>
          </li>
          <li
            v-else-if="selectedTopic.structuredLessonEditable && !isStudent"
            class="my-4"
          >
            <vx-card
              class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color"
            >
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient"
                    style="width: 70px;"
                  >
                    <span
                      ><feather-icon
                        class="pt-1 ml-3"
                        icon="GridIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  :disabled="true"
                  size="large"
                  class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                  style="border-radius:0 7px 7px 0;"
                  color=""
                >
                  Manage Structured Lesson
                </vs-button>
                <div class="fab_direction-up__manageSL">
                  <div class="float-btn-group">
                    <button
                      class="btn-float btn-triger school-primary_gradient"
                      @click="openManageSLMenu"
                    >
                      <i class="icon feather icon-more-horizontal text-white" />
                    </button>
                    <div class="btn-list">
                      <a
                        class="btn-float dc_dark-purple description glow-effect_dark"
                        @click="goToLesson"
                      >
                        <span class="descriptiontext">Preview</span>
                        <i class="icon feather icon-play text-white" />
                      </a>
                      <a
                        class="btn-float dc_dark-purple description glow-effect_dark"
                        @click="goToBuilder"
                      >
                        <span class="descriptiontext">Add/Edit</span>
                        <i class="icon feather icon-edit text-white" />
                      </a>
                    </div>
                  </div>
                </div>
              </vx-input-group>
            </vx-card>
          </li>
          <li
            v-if="
              !selectedTopic.structuredLessonAvailable &&
                selectedTopic.structuredLessonEditable &&
                !isStudent
            "
            class="my-4"
          >
            <vx-card
              class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color"
            >
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient"
                    style="width: 70px;"
                  >
                    <span
                      ><feather-icon
                        class="pt-1 ml-3"
                        icon="GridIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  id="add-standalone-content-btn"
                  size="large"
                  class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                  style="border-radius:0 7px 7px 0;"
                  color=""
                  @click="goToBuilder"
                >
                  Add Structured Lesson
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
        <div v-if="showMilestones">
          <div class="limit-width_fixed-scalable" style="text-align: left;">
            <li>
              <vx-card
                class="glow-effect_bg-color__blend card__no-padding bg-color"
                style="width: 410px"
              >
                <vx-input-group>
                  <vs-button
                    :disabled="true"
                    size="large"
                    class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                    type="filled"
                    color=""
                  >
                    Or, continue from a Milestone
                  </vs-button>
                </vx-input-group>
              </vx-card>
            </li>
          </div>
          <li
            v-for="(_milestone, index) in milestones"
            :key="index"
            class="mb-5"
          >
            <vx-card
              class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color"
            >
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text limit-height_content-height input-group_prepend-slot-bg"
                    style="width: 70px;border-radius: 5px 0 0 5px !important;"
                  >
                    <span
                      ><feather-icon
                        class="pt-1 ml-3"
                        icon="AnchorIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full glow-effect_primary limit-height_content-height button-text__left-align school-primary_gradient"
                  style="border-radius:0 7px 7px 0;"
                  @click="
                    continueFromMilestone(
                      _milestone.moduleId,
                      _milestone.taskDisplayId
                    )
                  "
                >
                  {{ _milestone.taskName }}<br />{{
                    "(" + _milestone.dateLastAccessed + ")"
                  }}
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
          <div
            v-show="!showAdditional"
            class="limit-width_fixed-scalable mb-4"
            style="text-align: left;"
          >
            <li>
              <p
                style="font-size: 11pt;"
                class="text__school-tertiary-color underline__hover-only"
                @click="showAdditional = true"
              >
                Or, click here to view Additional Resources
              </p>
            </li>
          </div>
        </div>
        <div v-show="showAdditional">
          <div
            v-if="numberOfTasks > 0"
            class="limit-width_fixed-scalable"
            style="text-align: left;"
          >
            <li>
              <vx-card
                class="glow-effect_bg-color__blend card__no-padding bg-color"
              >
                <vx-input-group>
                  <vs-button
                    :disabled="true"
                    size="large"
                    style="width:100%"
                    class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-tertiary-color bg-color"
                    type="filled"
                    color=""
                  >
                    {{
                      selectedTopic.structuredLessonAvailable
                        ? "Or, select an item in the topic"
                        : "Now, select an item in the topic"
                    }}
                  </vs-button>
                </vx-input-group>
              </vx-card>
            </li>
          </div>

          <div v-for="(_site, siteIndex) in sites" :key="siteIndex">
            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li>
                <vx-card
                  class="glow-effect_bg-color__blend card__no-padding mb-2 bg-color"
                  style="width: 410px"
                >
                  <vx-input-group>
                    <template slot="prepend">
                      <div
                        class="school-logo_container prepend-text glow-effect_bg-color__blend limit-height_content-height bg-color"
                        style="width: 70px;border-radius: 5px 0 0 5px !important;padding-left: 0.6rem !important;"
                      >
                        <span
                          ><img id="school_logo_img" :src="_site.logoUrl"
                        /></span>
                      </div>
                    </template>

                    <vs-button
                      :disabled="true"
                      size="large"
                      class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-item text__school-font-color bg-color"
                      type="filled"
                      color=""
                    >
                      {{ _site.name + " Items" }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>
              </li>
            </div>

            <li
              v-for="(_task, index) in standaloneContent.tasks.filter(function(
                item
              ) {
                return item.siteLevel == _site.level;
              })"
              
              
              :key="index"
              class="mb-4"
            >

              <vx-card 
                id="standalone-content-card"
               
                class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color"
              >
                <vx-input-group>
                  <template slot="prepend">
                    <vs-button
                      v-if="_task.isNew"
                      :disabled="true"
                      id="new-content"
                      size="small"
                      radius
                      color="#4e5c9a"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-star"
                      class="button__fully-opaque glow-effect_light"
                    ></vs-button>
                    <div
                      class="prepend-text glow-effect_dark limit-height_content-height input-group_prepend-slot-bg"
                      style="width: 70px;border-radius: 5px 0 0 5px !important;"
                    >
                      <span
                        ><feather-icon
                          class="pt-1 ml-3"
                          :icon="getIcon(_task)"
                          svg-classes="stroke-current"
                        ></feather-icon
                      ></span>
                    </div>
                  </template>

                  <vs-button
                    
                    size="large"
                    class="w-full glow-effect_primary_TopicContent limit-height_content-height button-text__left-align school-primary_gradient"
                    :class="[{ 'disabled_but-clickable padding-to-compensate-for-crown': (!canUserOpen() || (_task.allowMultipleSubmissions == false && _task.courseTaskLogEndDate && _task.courseTaskLogEndDate == true))}]"
                    
                    style="border-radius:0 7px 7px 0;"
                    @click=" contentSelected(_task, true)"
                  >
                  {{ _task.index + 1 }}) {{ getContentName(_task) }}
                    <p class="pt-1" v-if="_task.isAssessment">
                      <strong><small>Assessment</small></strong>
                    </p>
                    <p class="pt-1" v-if="_task.isClasswork">
                      <strong><small>Classwork</small></strong>
                    </p>
                    <p class="pt-1" v-if="_task.isTaskScheduled">
                      <strong
                      
                        ><small>{{
                          formatDate(_task.scheduleDTO.fromDate) +
                            " " +
                            _task.scheduleDTO.fromTime +
                            " - " +
                            formatDate(_task.scheduleDTO.toDate) +
                            " " +
                            _task.scheduleDTO.toTime
                        }}</small></strong
                      >
                    </p>
                    <p class="pt-1" v-if="_task.liveStream">
                      <strong
                        ><small>{{
                          formatDate(_task.liveStream.date) +
                            " " +
                            _task.liveStream.startTime +
                            " - " +
                            _task.liveStream.endTime
                        }}</small></strong
                      >
                    </p>
                    <p class="pt-1" v-else-if="_task.videoChat">
                      <strong
                        ><small>{{
                          formatDate(_task.videoChat.date) +
                            " " +
                            _task.videoChat.startTime +
                            " - " +
                            _task.videoChat.endTime
                        }}</small></strong
                      >
                    </p>
                  </vs-button>
                  <div id="crown-img-container">
                    <img v-if="_task.isPremium" class="footer-social ml-3" src="@/assets/images/royal-crown-with-three-picks-svgrepo-Gold.png" height="38"/>
                  </div>
                  <div v-if="!isStudent && _task.siteId == $getSiteId()">
                    <div class="fab_inline--button">
                      <div class="float-btn-group">
                        <button
                          :id="`task-${_task.id}`" class="btn-float btn-triger input-group_prepend-slot-bg"
                          @click="openActions"
                        >
                          <i
                            class="icon feather icon-more-horizontal text-white"
                          />
                        </button>
                        <div class="btn-list">
                          <a
                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="moveTaskUp(_task)"
                          >
                            <i
                              v-if="_task.index > 0"
                              class="icon feather icon-arrow-up-circle text-white"
                            ></i>
                          </a>
                          <a
                            v-show="!(_task.liveStream || _task.videoChat)"
                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="editTask(_task)"
                          >
                            <i class="icon feather icon-edit text-white"></i>
                          </a>
                          <a
                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="moveTaskDown(_task)"
                          >
                            <i
                              v-if="
                                _task.index < standaloneContent.tasks.length - 1
                              "
                              class="icon feather icon-arrow-down-circle text-white"
                            ></i>
                          </a>
                          <a
                            class="btn-float dc_dark-purple description glow-effect_dark"
                            @click="deleteTask(_task)"
                          >
                            <i
                              class="icon feather icon-trash-2 text-danger"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </vx-input-group>
              </vx-card>

              <vx-card
                v-if="
                  !isStudent &&
                    siteIndex == 0 &&
                    index ==
                      standaloneContent.tasks.filter(function(item) {
                        return item.siteLevel == _site.level;
                      }).length -
                        1
                "
                card-background="#11193f"
                class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding mt-4"
              >
                <vx-input-group>
                  <template slot="prepend">
                    <div
                      class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient"
                      style="width: 70px;"
                    >
                      <span
                        ><feather-icon
                          class="pt-1 ml-3"
                          icon="ArrowRightIcon"
                          svg-classes="stroke-current"
                        ></feather-icon
                      ></span>
                    </div>
                  </template>

                  <vs-button
                    :disabled="true"
                    size="large"
                    class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                    style="border-radius:0 7px 7px 0;"
                    color=""
                  >
                    Add an Item
                  </vs-button>
                  <div class="fab_direction-up__tasks">
                    <div class="float-btn-group">
                      <button
                        class="btn-float btn-triger school-primary_gradient"
                        @click="openTasksMenu"
                      >
                        <i class="icon feather icon-plus-circle text-white" />
                      </button>
                      <!-- <div class="btn-list">
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="addContent(6)"
                        >
                          <span class="descriptiontext">
                            Add an External Link Task</span
                          >
                          <i class="icon feather icon-link text-white"></i>
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="addContent(5)"
                        >
                          <span class="descriptiontext">
                            Add an Upload Task</span
                          >
                          <i class="icon feather icon-paperclip text-white"></i>
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="addContent(4)"
                        >
                          <span class="descriptiontext"> Add a Quiz</span>
                          <i class="icon feather icon-edit text-white"></i>
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="addContent(3)"
                        >
                          <span class="descriptiontext">Add a Podcast</span>
                          <i class="icon feather icon-mic text-white" />
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="addContent(2)"
                        >
                          <span class="descriptiontext">Add a Document</span>
                          <i class="icon feather icon-file-text text-white" />
                        </a>
                        <a
                          class="btn-float dc_dark-purple description glow-effect_dark"
                          @click="addContent(1)"
                        >
                          <span class="descriptiontext">Add a Video</span>
                          <i class="icon feather icon-youtube text-white"></i>
                        </a>
                      </div> -->
                    </div>
                  </div>
                </vx-input-group>
              </vx-card>
            </li>
          </div>
        </div>
        <vx-card
          v-if="!isStudent && numberOfTasks == 0"
          card-background="#11193f"
          class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding mt-5"
        >
          <vx-input-group>
            <template slot="prepend">
              <div
                class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient"
                style="width: 70px;"
              >
                <span
                  ><feather-icon
                    class="pt-1 ml-3"
                    icon="ArrowRightIcon"
                    svg-classes="stroke-current"
                  ></feather-icon
                ></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
              style="border-radius:0 7px 7px 0;"
              color=""
            >
              Or, Add Some Standalone Content
            </vs-button>
            <div class="fab_direction-up__tasks">
              <div class="float-btn-group">
                <button
                  class="btn-float btn-triger school-primary_gradient"
                  @click="openTasksMenu"
                >
                  <i class="icon feather icon-plus-circle text-white" />
                </button>
                <!-- <div class="btn-list">
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(6)"
                  >
                    <span class="descriptiontext"> Add an External Link Task</span>
                    <i class="icon feather icon-link text-white"></i>
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(5)"
                  >
                    <span class="descriptiontext"> Add an Upload Task</span>
                    <i class="icon feather icon-paperclip text-white"></i>
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(4)"
                  >
                    <span class="descriptiontext"> Add a Quiz</span>
                    <i class="icon feather icon-edit text-white"></i>
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(3)"
                  >
                    <span class="descriptiontext">Add a Podcast</span>
                    <i class="icon feather icon-mic text-white" />
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(2)"
                  >
                    <span class="descriptiontext">Add a Document</span>
                    <i class="icon feather icon-file-text text-white" />
                  </a>
                  <a
                    class="btn-float dc_dark-purple description glow-effect_dark"
                    @click="addContent(1)"
                  >
                    <span class="descriptiontext">Add a Video</span>
                    <i class="icon feather icon-youtube text-white"></i>
                  </a>
                </div> -->
              </div>
            </div>
          </vx-input-group>
        </vx-card>
        <p
          v-show="showComingSoon && isStudent"
          style="color:white;font-weight:500;font-size:16px;padding-top:5px"
        >
          Watch this space! Content coming soon...
        </p>
        <!-- <li v-if="!isStudent" class="mb-5">
          <vx-card card-background="#11193f" class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient" style="width: 70px;">
                  <span><feather-icon class="pt-1 ml-3" icon="ArrowRightIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                :disabled="true"
                size="large"
                class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align"
                style="border-radius:0 7px 7px 0;"
                color="#41475E">
                Add an Item
              </vs-button>
              <div class="fab_direction-up__tasks">
                <div class="float-btn-group">
                  <button class="btn-float btn-triger school-primary_gradient" @click="openTasksMenu">
                    <i class="icon feather icon-plus-circle text-white" />
                  </button>
                  <div class="btn-list">
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="addContent(3)">
                      <span class="descriptiontext">Add a Podcast</span>
                      <i class="icon feather icon-mic text-white" />
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="addContent(2)">
                      <span class="descriptiontext">Add a Document</span>
                      <i class="icon feather icon-file-text text-white" />
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="addContent(1)">
                      <span class="descriptiontext">Add a Video</span>
                      <i class="icon feather icon-youtube text-white"></i>
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="goToBuilder">
                      <span class="descriptiontext">Add a Structured Lesson</span>
                      <i class="icon feather icon-film text-white" />
                    </a>
                  </div>
                </div>
              </div>
            </vx-input-group>
          </vx-card>
        </li> -->
      </ul>
    </div>
    <b-modal
      id="task-popup"
      hide-backdrop
      centered
      hide-footer
      scrollable
      content-class="shadow"
      title="Add Task"
      v-model="tasksPopupActive"
      size="lg"
    >
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-input id="task-type-search-input" class="float-right" placeholder="Search..." v-model="taskTypeSearchVal" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/4 mb-3" v-for="(_task, index) in filteredTaskTypes" :key="index">
          <div class="task-item" @click="addContent(_task.value)">
            <div class="vx-row">
              <div class="vx-col w-full text-center">
                <i class="icon feather text-white" :class="`icon-${getTaskTypeIcon(_task.value)}`"></i>
              </div>
            </div>
            <div class="vx-row mt-2">
              <div class="vx-col w-full text-center">
                <h4>{{_task.text}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import 'animate.css';
import jQuery from './jquery';
import dobpicker from './dob-picker.js';
import { BIconFileEaselFill } from 'bootstrap-vue';
export default {
  components: {
    moment
  },
  data() {
    return {
      showAdditional: false,
      showMilestones: false,
      milestones: [],
      standaloneContent: {},
      cachingMinutes: 60,
      showComingSoon: false,
      fabElement: null,
      numberOfTasks: null,
      allSelectedData: {},
      sites: [],
      tasksPopupActive: false,
      taskTypeSearchVal: "",
      filteredTaskTypes: [],
      taskTypes: [
        {
          value: 1,
          text: "Video Task"
        },
        {
          value: 2,
          text: "Document Task"
        },
        {
          value: 3,
          text: "Podcast Task"
        },
        {
          value: 4,
          text: "Quiz Task"
        },
        {
          value: 5,
          text: "Upload Task"
        },
        {
          value: 6,
          text: "External Link Task"
        },
        {
          value: 7,
          text: "Presentation Task"
        },
      ],
      selectedTask:{}
    };
  },
  props: {
    isTopicContentViewActive: {
      required: false
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      type: Object,
      required: false
    },
    selectedSubject: {
      type: Object,
      required: true
    },
    selectedModule: {
      type: Object,
      required: true
    },
    selectedTopic: {
      type: Object,
      required: true
    },
    isTeacher: {
      type: Boolean,
      required: false
    },
    isUserPremium: {
      type: Boolean,
      required: false
    },
    activeSubscription: {
      type: Object,
      required: false
    },
  },
  watch: {
    isTopicContentViewActive: function(val) {
      if (val) {
        var self = this;
        self.getMilestones();
        self.allSelectedData = {
          selectedLanguage: self.selectedLanguage,
          selectedGrade: self.selectedGrade,
          selectedSubject: self.selectedSubject,
          selectedModule: self.selectedModule,
          selectedTopic: self.selectedTopic
        };
      }
    },
    showAdditional: function(val) {
      if (val) {
        var self = this;
        self.getStandaloneContent();
      }
    },
    taskTypeSearchVal: function(val) {
      this.filteredTaskTypes = this.taskTypes.filter(x => x.text.toLowerCase().includes(val.toLowerCase()));
    }
  },
  computed: {
    isTopicContentViewActiveLocal: {
      get() {
        return this.isTopicContentViewActive;
      }
    },
  },
  methods: {
    initValues() {
      this.standaloneContent = [];
      this.sites = [];
    },
    getStandaloneContent() {
      var self = this;
      self.showComingSoon = false;
      self.sites = [];
      var topicId = self.selectedTopic.id;

      if (self.isStudent) {
        var temp = localStorage.getItem("standaloneContent_" + topicId);
        var temp_sites = [];
        if (temp) {
          self.standaloneContent = JSON.parse(temp);
          self.numberOfTasks = self.standaloneContent
            ? self.standaloneContent.tasks.length
            : 0;

          temp_sites = self.standaloneContent.tasks.map(function(task) {
            return {
              level: task.siteLevel,
              logoUrl: task.siteLogoUrl,
              name: task.siteName
            };
          });
          temp_sites.forEach(_site => {
            if (
              self.sites.filter(function(item) {
                return _site.name == item.name;
              }).length == 0
            )
              self.sites.push(_site);
          });
          self.sites = self.sites.sort(function(a, b) {
            return a.level > b.level ? 1 : -1;
          });
        }
        var standaloneContentExpiryDate = localStorage.getItem(
          "standaloneContentExpiryDate_" + topicId
        );

        self.showComingSoon = self.standaloneContent.length == 0 ? true : false;
        if(!self.standaloneContent || !standaloneContentExpiryDate || standaloneContentExpiryDate < new Date().getTime() ) {

          self.showComingSoon = false;
          self.showLoadingOnElement("topic_content", 1, "material");

          var onSuccess = function(response) {
            if (response.data && response.data.tasks.length >= 0) {
              self.standaloneContent = response.data;
              localStorage.setItem(
                "standaloneContent_" + topicId,
                JSON.stringify(self.standaloneContent)
              );

              var timestamp =
                new Date().getTime() + self.cachingMinutes * 60000;

              localStorage.setItem(
                "standaloneContentExpiryDate_" + topicId,
                timestamp
              );

              temp_sites = self.standaloneContent.tasks.map(function(task) {
                return {
                  level: task.siteLevel,
                  logoUrl: task.siteLogoUrl,
                  name: task.siteName
                };
              });
              temp_sites.forEach(_site => {
                if (
                  self.sites.filter(function(item) {
                    return _site.name == item.name;
                  }).length == 0
                )
                  self.sites.push(_site);
              });
              self.sites = self.sites.sort(function(a, b) {
                return a.level > b.level ? 1 : -1;
              });
            }
            self.showComingSoon =
              self.standaloneContent.tasks.length == 0 ? true : false;
          };

          var onFinally = function(response) {
            self.$vs.loading.close(self.$refs.topic_content.$el);
            self.numberOfTasks = self.standaloneContent
              ? self.standaloneContent.tasks.length
              : 0;
          };

          if(self.$getSiteId() == 21){
            self.$ajaxGetAnonNoCache(self,"Module/GetStandaloneContent?topicId=" +topicId +"&siteId=" +self.$getSiteId()+"&userId=" + localStorage.getItem("Current_User_Id"), onSuccess,onFinally);
          }
          else{
            self.$ajaxGetAnon(self,"Module/GetStandaloneContent?topicId=" +topicId +"&siteId=" +self.$getSiteId()+"&userId=" + localStorage.getItem("Current_User_Id"), onSuccess,onFinally);
          }
          
        }
      } else {
        self.showComingSoon = false;
        self.showLoadingOnElement("topic_content", 1, "material");

        var onSuccess = function(response) {
          if (response.data && response.data.tasks.length >= 0) {
            self.standaloneContent = response.data;
            temp_sites = self.standaloneContent.tasks.map(function(task) {
              return {
                level: task.siteLevel,
                logoUrl: task.siteLogoUrl,
                name: task.siteName
              };
            });
            temp_sites.forEach(_site => {
              if (
                self.sites.filter(function(item) {
                  return _site.name == item.name;
                }).length == 0
              )
                self.sites.push(_site);
            });
            self.sites = self.sites.sort(function(a, b) {
              return a.level > b.level ? 1 : -1;
            });
          }
          self.showComingSoon =
            self.standaloneContent.tasks.length == 0 ? true : false;
        };

        var onFinally = function(response) {
          self.$vs.loading.close(self.$refs.topic_content.$el);
          self.numberOfTasks = self.standaloneContent
            ? self.standaloneContent.tasks.length
            : 0;
        };

        self.$ajaxGetAnon(self, "Module/Admin/GetStandaloneContent?topicId=" + topicId + "&siteId=" + self.$getSiteId(), onSuccess, onFinally);
      }
    },
    getMilestones() {
      var self = this;
      self.showMilestones = false;
      self.showAdditional = false;

      self.showLoadingOnElement("topic_content", 1, "material");

      var onSuccess = function(response) {
        self.milestones = response.data
          .filter(function(item) {
            return item.isMilestone;
          })
          .sort((a, b) =>
            Date.parse(a.sortDate) < Date.parse(b.sortDate) ? 1 : -1
          );
        self.showMilestones = true;
        self.showAdditional = false;
        if (self.milestones.length == 0) {
          self.showMilestones = false;
          self.showAdditional = true;
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.topic_content.$el);
      };

      self.$ajaxGet(
        self,
        "Module/GetMilestones/" + self.selectedTopic.id,
        onSuccess,
        onFinally
      );
    },
    continueFromMilestone(moduleId, taskDisplayId) {
      localStorage.setItem("currentModule", moduleId);
      this.$router.push({
        name: "DigiStoryViewer",
        params: {
          mode: "story",
          taskDisplayId: taskDisplayId,
          moduleId: moduleId,
          isStudent: "true"
        }
      });
    },
    contentValidation(task,continueToTask,checkSubject){
      var self = this;
      if(self.$getSiteIdWithContent() != self.$getSiteId()){
        continueToTask();
        return;
      }
      if(task.isPremium){
        if(self.$store.state.aclSubscription.status.includes("PremiumContent")){
          if(self.activeSubscription.preElective || self.activeSubscription.preElective == 0){
            var onSuccess = response =>{
              if(response.data){
                continueToTask();
              }
              else{
                checkSubject();
              }
            }
            self.$ajaxGet(self, `public/caniaccess?taskId=${task.id}&premiumGrade=${self.activeSubscription.preElective}` , onSuccess,);
          }
          else{
            checkSubject();
          }
        }
        else{
          this.showUnableToAccessContentPopup();
        }
      }
      else{

        var onSuccess = resonse =>{
          continueToTask();
        }

        var onFail = resonse =>{
          this.showUnableToAccessContentPopup();
        }
        if(task.video == null){
        }
        else{
          if(self.$store.state.aclSubscription.status.includes("Videos")){
            if((self.activeSubscription.id && self.activeSubscription.subjectIds.includes(self.selectedSubject.id))){
              continueToTask();
            }
            else{
              if((self.activeSubscription.preElective || self.activeSubscription.preElective == 0)){
                self.checkIfInCorrectGradeReturn(self.activeSubscription.preElective,onSuccess,onFail)
              }
              else{
                onFail();
              }
            }
          }
            
        }
      }
    },
    contentSelected(task, showPopup) {
      var self = this;
             
            
              var selectedData = {
                selectedLanguage: self.selectedLanguage,
                selectedGrade: self.selectedGrade,
                selectedSubject: self.selectedSubject,
                selectedModule: self.selectedModule,
                selectedTopic: self.selectedTopic
              
              };
            self.$emit(
              "contentSelected",
              task,
              task.index,
              self.standaloneContent,
              selectedData
            );
    },
    canUserOpen(){
      var self = this;
      var canOpen = false;
      if(self.selectedTopic.isPremium){
        if(self.isUserPremium){
          if((self.activeSubscription.id && self.activeSubscription.subjectIds.includes(self.selectedSubject.id)) || (self.activeSubscription.preElective || self.activeSubscription.preElective == 0) && self.checkSelectedGrade(self.activeSubscription.preElective)){
            canOpen = true;
          }
        }
      }
      else{
        canOpen = true;
      }
      return canOpen
    },
    goToLesson() {
      var self = this;
      if(self.canUserOpen()){
        if (self.isStudent) {
          var selectedData = {
            selectedSubject: self.selectedSubject,
            selectedModule: self.selectedModule,
            selectedTopic: self.selectedTopic,
            selectedGrade: self.selectedGrade
          };
        } else {
          var selectedData = {
            selectedLanguage: self.selectedLanguage,
            selectedGrade: self.selectedGrade,
            selectedSubject: self.selectedSubject,
            selectedModule: self.selectedModule,
            selectedTopic: self.selectedTopic
          };
        }
        localStorage.setItem("selectedData", JSON.stringify(selectedData));

        var moduleId = self.selectedTopic.id;
        var taskDisplayId = self.selectedTopic.startTaskDisplayId;

        var lastTask = localStorage.getItem("lastTask");
        var lastModule = localStorage.getItem("lastModule");

        if (lastModule && lastModule.toString() == moduleId.toString()) {
          if (lastTask) {
            moduleId = lastModule;
            taskDisplayId = lastTask;
          }
        }

        localStorage.setItem("currentModule", moduleId);
        self.$router.push({
          name: "DigiStoryViewer",
          params: {
            mode: "story",
            taskDisplayId: taskDisplayId,
            moduleId: moduleId,
            isStudent: "true",
          }
        });
      }
      else{
        self.showPremiumContentPopup("lesson");
      }
    },
    addContent(type) {
      // 1: video, 2: document
      var self = this;
      self.closeTasksMenu();
      var selectedData = {
        selectedLanguage: self.selectedLanguage,
        selectedGrade: self.selectedGrade,
        selectedSubject: self.selectedSubject,
        selectedModule: self.selectedModule,
        selectedTopic: self.selectedTopic
      };

      if (type == 1)
        self.$router.push({
          name: "AddVideo",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
      else if (type == 2)
        self.$router.push({
          name: "AddDocument",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
      else if (type == 3)
        self.$router.push({
          name: "AddPodcast",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
      else if (type == 4)
        self.$router.push({
          name: "AddQuiz",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
      else if (type == 5)
        self.$router.push({
          name: "AddUpload",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
      else if (type == 6)
        self.$router.push({
          name: "AddExternalLink",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
      else if (type == 7)
        self.$router.push({
          name: "AddPresentation",
          params: {
            selectedData: selectedData,
            numberOfTasks: self.numberOfTasks,
            isTeacher: self.isTeacher
          }
        });
    },
    backToPickLanguage() {
      this.initValues();
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.initValues();
      this.$emit("backToPickGrade");
    },
    backToPickSubject() {
      this.initValues();
      this.$emit("backToPickSubject");
    },
    backToPickModule() {
      this.initValues();
      this.$emit("backToPickModule");
    },
    backToPickTopic() {
      this.initValues();
      this.$emit("backToPickTopic");
    },
    formatDate(date) {
      var self = this;
      var dateString = new Date(Date.parse(date));

      var result = moment(dateString.toISOString()).format("DD MMMM YYYY");
      return result;
    },
    getIcon(task) {
      if (task.video) return "YoutubeIcon";
      else if (task.document) return "FileTextIcon";
      else if (task.podcast) return "MicIcon";
      else if (task.liveStream) return "VideoIcon";
      else if (task.videoChat) return "MonitorIcon";
      else if (task.upload) return "UploadIcon";
      else if (task.quiz) return "EditIcon";
      else if (task.externalLink) return "LinkIcon";
      else if (task.presentation) return "CastIcon";
    },
    getContentName(task) {
      if (task.video) return task.video.name;
      else if (task.document) return task.document.name;
      else if (task.podcast) return task.podcast.name;
      else if (task.liveStream) return task.liveStream.title;
      else if (task.videoChat) return task.videoChat.title;
      else if (task.upload) return task.upload.name;
      else if (task.quiz) return task.quiz.name;
      else if (task.externalLink) return task.externalLink.name;
      else if (task.presentation) return task.presentation.name;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    openManageSLMenu(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle("open");
      }
    },
    closeManageSLMenu() {
      if (this.fabElement) {
        this.fabElement.classList.remove("open");
      }
    },
    openTasksMenu() {
      var self = this;
      self.filteredTaskTypes = self.taskTypes;
      self.tasksPopupActive = true;
    },
    getTaskTypeIcon(value) {
      switch (value) {
        case 1:
          return "youtube";
        case 2:
          return "file-text";
        case 3:
          return "mic";
        case 4:
          return "edit";
        case 5:
          return "paperclip";
        case 6:
          return "link";
        case 7:
          return "cast";
        default:
          break;
      }
    },
    closeTasksMenu() {
      this.tasksPopupActive = false;
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle("open");
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove("open");
      }
    },
    editTask(task) {
      var self = this;

      var selectedData = {
        selectedLanguage: self.selectedLanguage,
        selectedGrade: self.selectedGrade,
        selectedSubject: self.selectedSubject,
        selectedModule: self.selectedModule,
        selectedTopic: self.selectedTopic
      };

      if (task.video)
        self.$router.push({
          name: "EditVideo",
          params: {
            selectedData: selectedData,
            videoTask: task,
            isTeacher: self.isTeacher
          }
        });
      else if (task.document)
        self.$router.push({
          name: "EditDocument",
          params: {
            selectedData: selectedData,
            documentTask: task,
            isTeacher: self.isTeacher
          }
        });
      else if (task.podcast)
        self.$router.push({
          name: "EditPodcast",
          params: {
            selectedData: selectedData,
            podcastTask: task,
            isTeacher: self.isTeacher
          }
        });
      else if (task.upload)
        self.$router.push({
          name: "EditUpload",
          params: {
            selectedData: selectedData,
            uploadTask: task,
            isTeacher: self.isTeacher
          }
        });
      else if (task.quiz)
        self.$router.push({
          name: "EditQuiz",
          params: {
            selectedData: selectedData,
            quizTask: task,
            isTeacher: self.isTeacher
          }
        });
      else if (task.externalLink)
        self.$router.push({
          name: "EditExternalLink",
          params: {
            selectedData: selectedData,
            externalLinkTask: task,
            isTeacher: self.isTeacher
          }
        });
      else if (task.presentation)
        self.$router.push({
          name: "EditPresentation",
          params: {
            selectedData: selectedData,
            presentationTask: task,
            isTeacher: self.isTeacher
          }
        });
    },
    deleteTask(task) {
      var self = this;
      self.closeActions();
      var taskType = "";

      var onSuccess = function(response) {
        self.$vs.loading.close(self.$refs.topic_content.$el);
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: `${taskType} Deleted`,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash",
          time: 5500
        });
        self.getStandaloneContent();
      };

      var onFinally = function() {
        self.$vs.loading.close(self.$refs.topic_content.$el);
      };

      if (task.video) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "Video";
        self.$ajaxGet(
          self,
          "VideoTask/Delete/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.document) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "Document";
        self.$ajaxGet(
          self,
          "DocumentTask/Delete/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.podcast) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "Podcast";
        self.$ajaxGet(
          self,
          "PodcastTask/Delete/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.liveStream) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "LiveStream";
        self.$ajaxDelete(
          self,
          "LiveStreamTask/RemoveLiveStreamTask/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.upload) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "Upload";
        self.$ajaxDelete(
          self,
          "UploadTask/DeleteUploadTask/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.quiz) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "Quiz";
        self.$ajaxDelete(
          self,
          "QuizTask/DeleteQuizTask/" + task.id,
          onSuccess,
          onFinally
        );
      } else if (task.externalLink) {
        self.showLoadingOnElement("topic_content", 1, "material");
        taskType = "ExternalLink";
        self.$ajaxDelete(
          self,
          "ExternalLinkTask/DeleteExternalLinkTask/" + task.id,
          onSuccess,
          onFinally
        );
      }
    },
    moveTaskUp(task) {
      var self = this;
      self.closeActions();
      self.showLoadingOnElement("topic_content", 1, "material");

      var onSuccess = function(response) {
        self.$vs.loading.close(self.$refs.topic_content.$el);
        self.getStandaloneContent();
      };

      self.$ajaxGet(
        self,
        "Module/MoveTaskUp?moduleId=" +
          self.selectedTopic.id +
          "&index=" +
          task.number,
        onSuccess
      );
    },
    moveTaskDown(task) {
      var self = this;
      self.closeActions();
      self.showLoadingOnElement("topic_content", 1, "material");

      var onSuccess = function(response) {
        self.$vs.loading.close(self.$refs.topic_content.$el);
        self.getStandaloneContent();
      };

      self.$ajaxGet(self,"Module/MoveTaskDown?moduleId=" + self.selectedTopic.id + "&index=" + task.number, onSuccess);
    },
    goToBuilder() {
      var self = this;
      self.closeTasksMenu();
      localStorage.setItem("currentModule", self.selectedTopic.id);
      localStorage.setItem(
        "selectedData",
        JSON.stringify(self.allSelectedData)
      );
      // self.$router.push({ name: 'DigiCourseBuilder' });
      let routeData = self.$router.resolve({ name: "DigiCourseBuilder" });
      window.open(routeData.href, "_self");
    },
    isLiveStreamVisable(task){
      var self = this;
      
      var show = true;
      if(task.liveStream){
        var stream = task.liveStream;
        var today = new Date();
        var taskSplit = stream.date.split("T");
        var customTime = taskSplit[0]+"T"+stream.endTime +":00";
        var taskDay = new Date(customTime);
        if(today > taskDay){
          show = false;
        }
      }
      return show;
    },

    getShouldTaskBeClickable(scheduleIno){
      if(!scheduleIno){
        return false;
      }
      var currentDate = new Date();

      var fromTime = scheduleIno.fromTime.split(':');
      var fromDate = new Date(scheduleIno.fromDate);
      fromDate.setHours(fromTime[0], fromTime[1], fromTime[2]);

      var toTime = scheduleIno.toTime.split(':');
      var toDate = new Date(scheduleIno.toDate);
      toDate.setHours(toTime[0], toTime[1], toTime[2]);

      if(fromDate<=currentDate && toDate>= currentDate){
        return false;
      }else{
        return true;
      }
    },
    showPremiumContentPopup(type) {
      var self = this;
      self.$swal({
        title: 'Cannot Continue',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Subscribe',
        html: `This is a premium ${type}. <br> To access this content you have to be a <strong>premium subscriber</strong>.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) { // <-- if confirmed
          // window.open("/subscriptions");
          self.checkIfDOBCaptured();
        }
      });
    },
    showAllowMultipleSubmissionsPopup(task) {
      var self = this;
      self.$swal({
        title: 'Please Note',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Continue',
        html: `Only <strong>one</strong> submission is allowed.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) { // <-- if confirmed
          self.contentSelected(task, false);
        }
      });
    },
    showIncorrectSubjectsPopup() {
      var self = this;
      self.$swal({
        title: 'Cannot Continue',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: 'OK',
        html: `Your current premium subscription does not allow you to access this premium content in <strong style="font-style: italic;">${self.selectedSubject.name}</strong>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3'
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      });
    },
    showUnableToAccessContentPopup() {
      var self = this;
      self.$swal({
        title: 'Cannot Continue',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: 'OK',
        html: `Your current subscription does not allow you to access this content</strong>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3'
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      });
    },
    checkIfDOBCaptured() {
      var self = this;
      var onSuccess = function(response) {
        if (response.data === true) {
          window.open("/subscriptions?ref=subscribe");
        } else {
          console.log("no")
          self.$swal({
            title: 'Missing required information',
            icon: 'question',
            backdrop: true,
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            html: "It looks like we don't have your date of birth on record.<br>Please use the dropdowns below to choose your date of birth."
                  + `
                    <div id="dob-pickers" class="flex">
                      <div id="dob-picker" style="padding: 0 0 0 5px;" class="mb-2 mt-3"></div>
                    </div>
                  `,
            customClass: {
              confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
              cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
            },
            showClass: {
              popup: 'animate__animated animate__bounceIn dob-swal-popup',
            },
            buttonsStyling: false,
            preConfirm: () => {
              return $("#date-of-birth").val() ? true : false
            }
          }).then((result) => {
            var dateOfBirth = $("#date-of-birth").val();
            if (result.value && dateOfBirth) { // <-- if confirmed

              if (dateOfBirth) {
                self.submitDob(dateOfBirth);
              }
            }
          });

          self.initDobPickers();
        }
      };
      self.$ajaxGet(self, "User/CheckIfDobCaptured" , onSuccess);
    },
    submitDob(dob) {
      var self = this;
      self.showLoadingOnElement("topic_content", 1, "material");
      var onSuccess = function(response) {
        var userInfo = JSON.parse(localStorage.getItem('userInfo'));
        userInfo.dateOfBirth = dob;
        localStorage.setItem('userInfo', JSON.stringify(userInfo));

        window.open("/subscriptions?ref=subscribe");
      };
      var onFinally = function() {
        if (self.$refs.topic_content) {
          self.$vs.loading.close(self.$refs.topic_content.$el);
        }
      };
      self.$ajaxGet(self, `User/UpdateDateOfBirth/${dob}`, onSuccess, onFinally);
    },
    initDobPickers() {
      $("#dob-picker").birthdayPicker({
        "monthFormat": "long",
        "sizeClass": "span3",
        "dateFormat": "littleEndian"
      });
    },
    checkSelectedGrade(premiumGrade){
      var self = this;
      premiumGrade = premiumGrade.toString();
      if(premiumGrade){
        var canContinue = self.checkIfInCorrectGrade(premiumGrade);
        setTimeout(() => {
          return canContinue;
        }, 1000);
      }
      return false;
    },
    checkIfInCorrectGradeReturn(premiumGrade,onTrue,onFail){
      var self = this;

      var onSuccess = response =>{
        if(response.data){
          onTrue();
        }
        else{
          onFail();
        }
      }
      self.$ajaxGet(self, `public/caniaccess?taskId=${self.selectedTask.id}&premiumGrade=${premiumGrade.toString()}` , onSuccess,);
    },
    checkIfInCorrectGrade(premiumGrade){
      var self = this;

      var onSuccess = response =>{
        return response.data;
      }
      self.$ajaxGet(self, `public/caniaccess?taskId=${self.selectedTask.id}&premiumGrade=${premiumGrade}` , onSuccess,);
    },
  }
};
</script>
<style lang="scss" scoped>
.fab_inline--button {
  right: 0.5vw;
  bottom: 1.5vh;
  z-index: 999;
  position: absolute;
}

.fab_direction-up__tasks {
  right: 0.9vw;
  bottom: 0.7vh;
  z-index: 999;
  position: absolute;
}

.fab_direction-up__manageSL {
  right: 0.9vw;
  bottom: 0.7vh;
  z-index: 999;
  position: absolute;
}
</style>

<style lang="scss">
.popup_class .vs-popup {
  background: rgb(65, 71, 94) !important;
  color: rgb(202, 202, 202) !important;
  > header.vs-popup--header {
    background: rgb(38, 45, 74) !important;

    > div.vs-popup--title > h3 {
      color: rgb(255, 255, 255) !important;
    }
  }

  .vs-popup--content {
    height: inherit !important;
  }
}

#school_logo_img {
  width: 50px;
  height: 50px;
}

#task-type-search-input {
  &.vs-input--input {
    border-radius: 30px !important;
  }
}

#task-type-search-input + .vs-input--placeholder {
  height: 100% !important;
  padding-top: 14px !important;
}

.task-item {
  padding: 10px;
  // height: 135px;
  border: 1px solid transparent;
  border-radius: 20px;
  &:hover {
    background-color: rgba(var(--vs-primary), 0.2) ;
    cursor: pointer;
    border: 1px solid rgba(255,255,255,0.3);
  }
  i {
    width: 70px;
    height: 70px;
    line-height: 70px;
    display: inline-block;
    // border: none;
    font-size: 30px;
    color: #fff;
    text-align: center;
    position: relative;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.11);
    border-style: solid;
    border-color: rgba(var(--vs-primary), 0.5);
    border-width: 2px;
    background-color: rgba(255, 255, 255, 0.09);
  }
}

.glow-effect_primary_TopicContent {
  box-shadow: 0 0 8px 2px rgba(var(--vs-primary), 1);
}

[id^=task-popup] {
  z-index: 42000 !important;
}

.dob-swal-popup {
  &.swal2-popup {
    width: 40em !important;
  }

  #dob-pickers {
    $glass: rgba(255, 255, 255, 0.2);
    $glass-icon: rgba(255, 255, 255, 0.3);
    $option: #616161;

    /* <select> styles */
    select {
      /* Reset */
      appearance: none;
      border: 0;
      outline: 0;
      font: inherit;
      /* Personalize */
      height: 3em;
      padding: 0 4em 0 1em;
      background: url(https://upload.wikimedia.org/wikipedia/commons/9/9d/Caret_down_font_awesome_whitevariation.svg)
          no-repeat right 0.8em center / 1.4em,
        linear-gradient(to left, $glass-icon 3em, $glass 3em);
      color: white;
      border-radius: 0.25em;
      box-shadow: 0 0 1em 0 rgba(0, 0, 0, 0.2);
      cursor: pointer;
      /* <option> colors */
      option {
        color: inherit;
        background-color: $option;
      }
      /* Remove focus outline */
      &:focus {
        outline: none;
      }
      /* Remove IE arrow */
      &::-ms-expand {
        display: none;
      }
    }

  }
}

</style>
